import type { ReactNode } from 'react'

import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import { AnswerIcon } from '@twistopayments/design-system/icons/inline'

import { useAdditionalData } from '../../libs/context'

import * as styles from './short-answer.styles'

type Props = {
  children: ReactNode
}
export const ShortAnswer = ({ children }: Props) => {
  const { staticTexts } = useAdditionalData()

  return (
    <div css={styles.container}>
      <div>
        <Typography
          component="h2"
          css={styles.headline}
          fontWeight="medium"
          variant="b2"
        >
          <AnswerIcon css={styles.icon} height="1em" width="1em" />
          {staticTexts?.shortAnswerTitle || ''}
        </Typography>
      </div>
      <Typography variant="b2">{children}</Typography>
    </div>
  )
}
